module.exports = __webpack_public_path__ + "static/media/2020-05-27-01.7323a612.jpg";